import script from "./startup-application-header.vue?vue&type=script&setup=true&lang=js"
export * from "./startup-application-header.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__